export function isCacheMiss(result) {
    switch (result.kind) {
        case "CacheEmpty":
        case "NoMatchingSlug":
            return true;
        case "Loading":
        case "Fail":
        case "Success":
            return false;
    }
}
